import React, { useState, useEffect, Fragment } from 'react';
import { Button } from 'reactstrap';
import { PageFile } from './ReportCreator';
import { Camera, Monitor, Share2, StopCircle } from 'react-feather';
import { P } from '../../../AbstractElements';
import { toast } from 'react-toastify';

interface VideoRecorderProps {
  setPageFile: (file: PageFile) => void;
}

interface DropZoneFile {
  file: File;
  name: string | undefined;
  type: string | undefined;
  valid: boolean;
}

const VideoRecorder: React.FC<VideoRecorderProps> = ({ setPageFile }) => {
  const [stream, setStream] = useState<MediaStream | null>(null);
  const [recorder, setRecorder] = useState<MediaRecorder | null>(null);
  const [chunks, setChunks] = useState<Blob[]>([]);
  const [recording, setRecording] = useState<boolean>(false);

  const startRecording = async (sourceType: 'camera' | 'screen') => {
    try {
      let mediaStream: MediaStream;
      if (sourceType === 'camera') {
        mediaStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      } else {
        mediaStream = await navigator.mediaDevices.getDisplayMedia({ video: true });
      }
      setStream(mediaStream);
      const mediaRecorder = new MediaRecorder(mediaStream);
      mediaRecorder.ondataavailable = (e: BlobEvent) => {
        if (e.data && e.data.size > 0) {
          setChunks(prev => [...prev, e.data]);
        }
      };
      mediaRecorder.start();
      setRecorder(mediaRecorder);
      setRecording(true);
    } catch (error) {
      if (sourceType === 'camera') {
        toast.error("Cannot find camera device")
      }
    }
  };

  const stopRecording = () => {
    recorder?.stop();
    stream?.getTracks().forEach(track => track.stop()); // Stop all tracks to release the camera or screen capture
    setRecording(false);
  };

  useEffect(() => {
    if (!recording && chunks.length) {
      const blob = new Blob(chunks, { type: 'video/mp4' });
      const file = new File([blob], "recorded.mp4", { type: 'video/mp4' });
      const dropZoneFile: DropZoneFile = { file: file, name: file.name, type: file.type, valid: true }
      setPageFile({ file: dropZoneFile, id: Math.random().toString() });
      setChunks([]);
    }
  }, [recording, chunks, setPageFile]);

  return (
    <Fragment>
      <P>Or Recording</P>
      <div className='rounded p-3 py-4 mb-3'
        style={{
          border: "1px solid rgba(100, 108, 127, 1)",
          borderRadius: 8
        }}>
        <div className='d-flex justify-content-between px-4'>
          <div>
            <Button color="primary mb-1 px-3 pt-2 pb-1 btn-hover-effect" onClick={() => startRecording('camera')} style={{ fontSize: 16 }}><Camera width={20} height={20} /></Button>
          </div>
          <div>
            <Button color="primary mb-1 px-3 pt-2 pb-1 btn-hover-effect" onClick={() => startRecording('screen')}><Share2 width={20} height={20} /></Button>
          </div>
        </div>
        <div className={`d-flex justify-content-center px-4 ${recording ? "btn-hover-effect" : ""}`}>
          <Button color="danger mt-1 pt-2 pb-1 w-100" onClick={stopRecording} disabled={!recording}><StopCircle width={24} height={24} /></Button>
        </div>
      </div >
    </Fragment >
  );
};

export default VideoRecorder;
